import React, { Component } from "react";
import {
  NormalInput,
  NormalButton,
  TableWrapper,
  NormalDate,
  NormalTextarea,
  NormalSelect,
  NormalCheckbox,
  NormalModal,
  SearchInputKeyboard,
} from "component/common";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getCommonApi,
  commonPatchApi,
  commonCreateApi,
  commonUpdateApi,
} from "redux/actions/common";
import "./style.scss";
import { Toast } from "service/toast";
import closeIcon from "assets/images/close.png";
import { CourseTreatmentDone } from "./coursetreatmentDone";
import { withTranslation } from "react-i18next";
import _ from "lodash";
import { StaffSelectionPopup } from "./staffSelectionPopup";
import { CredentialConfirmation } from "../credentialConfirmation";
import { dateFormat } from "service/helperFunctions";
import { NumPadKeyboard } from "component/common/NumPadKeyboard";
import { InputKeyboard } from "component/common/InputKeyboard";

export class CoursePopupClass extends Component {
  constructor(props) {
    super(props);
    this.childInput = React.createRef();
  }
  state = {
    headerDetails: [
      { label: "No.", divClass: "justify-content-end text-right" },
      { label: "Program" },
      { label: "Next appt", divClass: "justify-content-end text-right" },
      { label: "Amount", divClass: "justify-content-end text-right" },
    ],
    data_list: {
      deposit: "",
      discount: "",
      discount_amt: "",
      discount_price: "",
      free_sessions: null,
      id: null,
      itemdesc: "",
      remark: "",
      price: "",
      quantity: null,
      tmp_treatment: [],
      total_price: "",
      trans_amt: "",
      treatment_no: null,
      outstanding: null,
      disc_reason: "182",
      discreason_txt: "",
      autoProportion: false,
      Sessions: "",
    },
    discount_reason_options: [],
    is_percentage: "1",
    discount_reasons: [],
    is_total: false,
    discount_price_txt: "",
    discType: [
      { value: 1, label: "%" },
      { value: 2, label: "$" },
    ],
    options_course_type: [
      { value: "N", label: "Normal" },
      { value: "FFd", label: "Fixed" },
      { value: "FFi", label: "Flexi" },
    ],
    course_type: "N",
    course_type_expiry_date: new Date(),
    course_type_max_treat_qty: 0,
    TD_List: [],
    isOpenTreatmentDone: false,
    cartId: null,
    item: {},
    summaryFlag: false,
    sessionStaff: [],
    TempSave: false,
    isOpenStaffSelectionDetail: false,
    settingData: {},
    isHandleConfirmationDialog: false,
    isLoginConfirmation: false,
    user: "",
    pass: "",
    changeprice: 0,
    isStaffLoginConfirmation: false,
  };

  componentDidMount = () => {
    if (this.props.tokenDetails.courseautoproportion) {
      let { data_list } = this.state;
      data_list["autoProportion"] = true;
      this.setState({ data_list });
    }
    this.getDiscountReasons();
    this.setState({
      item: this.props.itemData,
    });
    this.getCourseList();
    this.handleItemSettings();
  };

  handleItemSettings = () => {
    let { settingData } = this.state;
    this.props.getCommonApi(`userlist/`).then((key) => {
      let { status, data } = key;
      console.log(key, "settingsData salesstaff");
      if (status === 200) {
        settingData = data;
        this.setState({ settingData });
      }
    });
  };

  getCourseList = () => {
    let {
      data_list,
      discount_reasons,
      is_total,
      sessionStaff,
      TempSave,
      course_type,
      course_type_expiry_date,
      changeprice,
      course_type_max_treat_qty,
    } = this.state;
    this.props
      .getCommonApi(`cartservicecourse/${this.props.cartId}/`)
      .then(async (key) => {
        let { status, data } = key;
        console.log(data, "cartcoursepopup");
        if (status == "200") {
          if (data) {
            data_list["deposit"] = data.deposit
              ? Number(data.deposit).toFixed(2)
              : 0;
            data_list["discount"] = 0;
            data_list["discount_amt"] = 0;
            data_list["discount_price"] = Number(data.discount_price);
            data_list["free_sessions"] = data.free_sessions;
            data_list["id"] = data.id;
            data_list["itemdesc"] = data.itemdesc;
            data_list["price"] = data.price;
            data_list["remark"] = data.remark;
            data_list["quantity"] = data.quantity;
            data_list["tmp_treatment"] = data.tmp_treatment;
            data_list["autoProportion"] = data?.auto_proportion ?? false;
            data_list["total_price"] = Number(data.total_price).toFixed(2);
            data_list["trans_amt"] = data.trans_amt;
            data_list["treatment_no"] =
              Number(data.quantity) >= 1 && Number(data.free_sessions) == 0
                ? data.quantity
                : data.treatment_no;
            // data_list["treatment_no"] =
            //   Number(data.quantity) == 1
            //     ? 1
            //     : data.free_sessions == 0
            //     ? data.quantity
            //     : data.treatment_no;
            data_list["outstanding"] = Number(
              data.trans_amt - data.deposit
            ).toFixed(2);
            data_list["is_done"] = data.is_done;

            course_type = data.treat_type == null ? "N" : data.treat_type;
            course_type_expiry_date =
              data.treat_expiry == null ? new Date() : data.treat_expiry;
            course_type_max_treat_qty = data.treatment_limit_times;

            if (
              data.sessiondone == "" ||
              Number(data.sessiondone) == 0 ||
              data.sessiondone == null ||
              data.sessiondone == undefined
            ) {
              data_list["Sessions"] = 0;
            } else {
              data_list["Sessions"] = data.sessiondone;
            }
            is_total = data.is_total;
            discount_reasons = data.disc_lst;
            sessionStaff = [];
            if (data.tstaff) {
              sessionStaff = data.tstaff;
            }
            //TempSave = data.is_treat;
            changeprice = Number(data.trans_amt).toFixed(2);

            console.log("getcourseList", changeprice);

            await this.setState({
              data_list,
              discount_reasons,
              is_total,
              sessionStaff,

              course_type,
              course_type_expiry_date,
              course_type_max_treat_qty,
              changeprice,
              //TempSave,
            });
            // if (TempSave) {
            //   this.handleReset();
            // }
            // if (
            //   data_list.treatment_no == 1 &&
            //   data_list["tmp_treatment"].length <= 0
            // ) {
            //   this.handleTreatmentCountUpdate();
            // } else
            //;
            if (
              data_list.treatment_no == null &&
              data_list["tmp_treatment"].length == 0
            ) {
              this.handleTreatmentnewCountUpdate();
            } else if (
              data_list.treatment_no == 1 &&
              data_list["tmp_treatment"].length == 0
            ) {
              let dataFirstCall = true;
              this.handleTreatmentCountUpdate(dataFirstCall);
            }
          }
        }
      });
  };

  getCourseAfterTreatmentDoneConfirm = () => {
    let { sessionStaff, data_list } = this.state;
    this.props
      .getCommonApi(`cartservicecourse/${this.props.cartId}/`)
      .then((key) => {
        let { status, data } = key;
        console.log(data, "cartcoursepopup");
        if (status == "200") {
          if (data) {
            data_list["is_done"] = data.is_done;
            data_list["autoProportion"] = data?.auto_proportion ?? false;
            sessionStaff = [];
            sessionStaff = data.tstaff;
            this.setState({
              sessionStaff,
              data_list,
            });
          }
        }
      });
  };

  getCourseAfterTreatmentDoneAction = () => {
    let { sessionStaff, data_list } = this.state;
    this.props
      .getCommonApi(`cartservicecourse/${this.props.cartId}/`)
      .then((key) => {
        let { status, data } = key;
        console.log(data, "cartcoursepopup");
        if (status == "200") {
          if (data) {
            data_list["is_done"] = data.is_done;
            data_list["autoProportion"] = data?.auto_proportion ?? false;
            if (
              data.sessiondone == "" ||
              Number(data.sessiondone) == 0 ||
              data.sessiondone == null ||
              data.sessiondone == undefined
            ) {
              data_list["Sessions"] = 0;
            } else {
              data_list["Sessions"] = data.sessiondone;
            }
            sessionStaff = [];
            sessionStaff = data.tstaff;
            this.setState({
              sessionStaff,
              data_list,
            });
          }
        }
      });
  };

  getCourseTableList = async () => {
    let {
      data_list,
      discount_reasons,
      discount_price_txt,
      is_percentage,
      changeprice,
    } = this.state;
    this.props
      .getCommonApi(`cartservicecourse/${this.props.cartId}/`)
      .then(async (key) => {
        let { status, data } = key;
        console.log(key, "cartcoursepopupafterdiscount");
        if (status == "200") {
          if (data) {
            data_list["tmp_treatment"] = data.tmp_treatment;
            data_list["autoProportion"] = data?.auto_proportion ?? false;
            discount_reasons = data.disc_lst;
            this.setState({ data_list, discount_reasons });
            //data_list["discount_price"] = data.discount_price;
            data_list["discount_price"] = Number(data.discount_price);
            let Total = 0;
            if (
              Number(data_list.treatment_no) === 0 &&
              Number(data_list.free_sessions) === 0
            ) {
              Total = Number(data.discount_price) * Number(data_list.quantity);
            } else {
              Total =
                Number(data.discount_price) * Number(data_list.treatment_no);
            }

            data_list["total_price"] = Number(Total).toFixed(2);
            data_list["trans_amt"] = Number(Total).toFixed(2);
            data_list["deposit"] = Number(Total).toFixed(2);
            data_list["disc_reason"] = "182";
            data_list["discreason_txt"] = "";
            data_list["discount"] = "";
            data_list["discount_amt"] = "";
            data_list["outstanding"] = Number(
              Total - data_list.deposit
            ).toFixed(2);
            discount_price_txt = "";
            is_percentage = "1";
            changeprice = Number(Total).toFixed(2);
            console.log("cartservicecourse", changeprice);
            await this.setState({
              data_list,
              discount_reasons,
              discount_price_txt,
              is_percentage,
              changeprice,
            });
          }
        }
      });
  };

  handleProportionChange = async ({ target: { value, name } }) => {
    let { data_list, deposit, discount_price } = this.state;
    data_list[name] = value;
    let proportion = "";
    if (value) {
      proportion = "True";
    } else {
      proportion = "False";
    }
    let body = {
      cart_id: data_list.id,
      treatment_no: data_list?.treatment_no, //yoonus null to data_list?.treatment_no
      free_sessions: data_list?.free_sessions, //yoonus null to data_list?.free_sessions
      total_price: null,
      unit_price: null,
      disc_amount: null,
      disc_percent: null,
      auto_propation: proportion,
      unit_amount: data_list?.discount_price,
    };
    this.props.commonCreateApi(`coursetmp/`, body).then((key) => {
      let { status, data } = key;
      console.log(key, "Coursecountupdateresponse");
      if (status == "201" || status == "200") {
        if (data) {
          data_list["tmp_treatment"] = data;
          data_list["outstanding"] = Number(
            data_list.trans_amt - data_list.deposit
          ).toFixed(2);
          this.setState({ data_list });
          this.getCourseAfterTreatmentDoneConfirm();
          return true;
        }
      }
    });
  };

  // datepicker and selectdropdown
  handleChange1 = async ({ target: { value, name } }) => {
    let {
      data_list,
      deposit,
      is_percentage,
      course_type,
      course_type_expiry_date,
      course_type_max_treat_qty,
      discount_price_txt,
      total_price,
      outstanding,
      changeprice,
    } = this.state;

    console.log(name, value);

    //console.log("transamt" , data_list.trans_amt)

    if (name === "discount_price_txt") {
      discount_price_txt = value;
      this.setState({
        discount_price_txt,
      });
    } else if (name == "is_percentage") {
      is_percentage = value;
      this.setState({
        is_percentage,
      });
    } else if (name === "disc_reason") {
      data_list["discreason_txt"] = "";
      data_list["disc_reason"] = value;
      this.setState({
        data_list,
      });
    } else if (name === "course_type") {
      console.log("course type " + value);
      course_type = value;
      this.setState({
        course_type,
      });
    } else if (name === "course_type_expiry_date") {
      course_type_expiry_date = value;
      this.setState({
        course_type_expiry_date,
      });
    } else if (name === "course_type_max_treat_qty") {
      course_type_max_treat_qty = value;
      this.setState({
        course_type_max_treat_qty,
      });
    } else if (name === "changeprice") {
      changeprice = value;
      console.log("handleChange1", changeprice);
      this.setState({
        changeprice,
      });
    } else {
      data_list[name] = value;
      await this.setState({
        data_list,
      });
    }

    //changeprice
  };

  // handleInputChange
  handleChange = async (value, name) => {
    let {
      data_list,
      deposit,
      is_percentage,
      course_type,
      course_type_expiry_date,
      course_type_max_treat_qty,
      discount_price_txt,
      total_price,
      outstanding,
      changeprice,
    } = this.state;

    console.log(name, value);

    //console.log("transamt" , data_list.trans_amt)

    if (name === "discount_price_txt") {
      discount_price_txt = Number(value);
      this.setState({
        discount_price_txt,
      });
    } else if (name == "is_percentage") {
      is_percentage = Number(value);
      this.setState({
        is_percentage,
      });
    } else if (name === "disc_reason") {
      data_list["discreason_txt"] = "";
      data_list["disc_reason"] = Number(value);
      this.setState({
        data_list,
      });
    } else if (name === "course_type") {
      console.log("course type " + Number(value));
      course_type = Number(value);
      this.setState({
        course_type,
      });
    } else if (name === "course_type_expiry_date") {
      course_type_expiry_date = Number(value);
      this.setState({
        course_type_expiry_date,
      });
    } else if (name === "course_type_max_treat_qty") {
      course_type_max_treat_qty = Number(value);
      this.setState({
        course_type_max_treat_qty,
      });
    } else if (name === "changeprice") {
      changeprice = Number(value);
      console.log("handleChange", changeprice);
      this.setState({
        changeprice,
      });
    } else {
      data_list[name] = Number(value);
      await this.setState({
        data_list,
      });
    }

    //changeprice
  };

  handleTreatmentnewCountUpdate = () => {
    let { data_list } = this.state;
    console.log("handleTreatmentnewCountUpdate", data_list.total_price);
    let body = {
      cart_id: data_list.id,
      treatment_no: data_list.quantity,
      free_sessions: Number(data_list.free_sessions),
      total_price: Number(data_list.total_price).toFixed(2),
      auto: data_list.autoProportion ?? false,
      unit_amount: data_list?.discount_price,
    };
    this.apiCallforNewTreatmentCount(body);
    this.handleNewQuantityCount();
  };

  handleNewQuantityCount = async () => {
    let { data_list } = this.state;
    let count = 0;

    count = Number(data_list.quantity) + Number(data_list.free_sessions);
    if (count > 0) {
      data_list["quantity"] = count;
    } else {
      data_list["quantity"] = 1;
    }
    await this.setState({
      data_list,
    });
  };

  handleTreatmentCountUpdate = async (dataFirstCall, total_price = 0) => {
    let { data_list } = this.state;
    //console.log("handleTreatmentCountUpdate", data_list.total_price);
    //console.log("data_list.trans_amt", data_list.trans_amt);
    //Yoonus
    if (data_list.treatment_no && Number(data_list.treatment_no) > 0) {
      let body = {
        cart_id: data_list.id,
        treatment_no: Number(data_list.treatment_no),
        free_sessions: Number(data_list.free_sessions),
        total_price:
          total_price > 0
            ? Number(total_price)
            : Number(data_list.discount_price * data_list.treatment_no).toFixed(
                2
              ),
        auto: data_list.autoProportion ?? false,
        unit_amount: data_list?.discount_price,
      };

      //this.handleTextChangeAPI(body);

      this.apiCallforTreatmentCount(body, dataFirstCall, total_price);

      this.handleQuantityCount();
    } else {
      Toast({
        type: "error",
        message: "No.of treatment should not be empty",
      });
    }
  };

  apiCallforNewTreatmentCount = (body) => {
    let { data_list, changeprice } = this.state;
    this.props.commonCreateApi(`coursetmp/`, body).then(async (key) => {
      let { status, data } = key;
      console.log(key, "Coursecountupdateresponse");
      if (status == "201" || status == "200") {
        if (data) {
          data_list["tmp_treatment"] = data;
          this.setState({ data_list });
          this.getCourseAfterTreatmentDoneAction();
          let Amount = Number(
            data_list.discount_price * data_list.quantity
          ).toFixed(2);
          data_list["deposit"] = Amount;
          data_list["trans_amt"] = Amount;
          data_list["total_price"] = Amount;
          data_list["outstanding"] = Number(
            data_list.trans_amt - Amount
          ).toFixed(2);
          changeprice = Number(Amount).toFixed(2);
          console.log("Amount", changeprice);
          await this.setState({
            data_list,
            changeprice,
          });
          //this.getCourseAfterTreatmentDoneAction();
          return true;
        }
      }
    });
  };

  apiCallforTreatmentCount = (body, dataFirstCall, total_price = 0) => {
    let { data_list, changeprice } = this.state;
    this.props.commonCreateApi(`coursetmp/`, body).then(async (key) => {
      let { status, data } = key;
      console.log(key, "Coursecountupdateresponse");

      if (status == "201" || status == "200") {
        if (data) {
          data_list["tmp_treatment"] = data;
          this.setState({ data_list });
          this.getCourseAfterTreatmentDoneAction();
          let Amount = 0;
          // if (total_price > 0) {
          //   Amount = Number(total_price).toFixed(2);
          // } else {
          //   Amount = Number(
          //     data_list.discount_price * data_list.treatment_no
          //   ).toFixed(2);
          // }
          if (Number(data_list?.treatment_no) > 0) {
            Amount = Number(
              data_list.discount_price * data_list.treatment_no
            ).toFixed(2);
          } else {
            Amount = Number(total_price).toFixed(2);
          }
          if (!dataFirstCall) {
            data_list["deposit"] = Number(Amount).toFixed(2);
          }
          data_list["trans_amt"] = Amount;
          data_list["total_price"] = Number(Amount).toFixed(2);
          changeprice = Number(Amount).toFixed(2);
          console.log("apiCallforTreatmentCount");
          await this.setState({
            data_list,
            changeprice,
          });
          //this.getCourseAfterTreatmentDoneAction();
          this.handleOutstanding();
          return true;
        }
      }
    });
  };

  handleOutstanding = async () => {
    let { data_list } = this.state;
    data_list["outstanding"] = Number(
      data_list.trans_amt - data_list.deposit
    ).toFixed(2);
    await this.setState({
      data_list,
    });
  };

  handleTotalPriceChange = () => {
    let { data_list, is_total, changeprice } = this.state;
    console.log("handleTotalPriceChange", data_list.trans_amt);

    //Yoonus
    console.log("handleTotalPriceChange", changeprice);
    data_list.trans_amt = changeprice;
    //Yoonus

    if (data_list.treatment_no !== "" || Number(data_list.treatment_no) > 0) {
      if (data_list.trans_amt && Number(data_list.trans_amt) > 0) {
        let body = {
          cart_id: data_list.id,
          treatment_no: data_list?.treatment_no, //yoonus null to data_list?.treatment_no
          free_sessions:  data_list?.free_sessions, //yoonus null to data_list?.free_sessions
          total_price: Number(data_list.trans_amt).toFixed(2),
          unit_price: null,
          disc_amount: null,
          disc_percent: null,
          auto_propation: null,
          auto: data_list.autoProportion ?? false,
          unit_amount: data_list?.discount_price,
        };
        // this.handleTextChangeAPI(body);

        this.props.commonCreateApi(`coursetmp/`, body).then(async (key) => {
          let { status, data } = key;
          console.log(key, "Coursecountupdateresponse");
          if (status == "201" || status == "200") {
            if (data) {
              data_list["tmp_treatment"] = data;
              this.setState({ data_list });
              this.getCourseAfterTreatmentDoneAction();
              //Yoonus checking discount infinity error
              if (data_list.treatment_no == null)
                data_list.treatment_no = data_list.quantity;
              let Amount = Number(
                data_list.trans_amt / data_list.treatment_no
              ).toFixed(2);
              data_list["price"] = Amount;
              data_list["total_price"] = Number(data_list.trans_amt).toFixed(2);
              data_list["trans_amt"] = data_list.trans_amt;
              data_list["deposit"] = Number(data_list.trans_amt).toFixed(2);
              data_list["discount_price"] = data_list.price;
              data_list["discount"] = "";
              data_list["discount_amt"] = "";
              data_list["outstanding"] = Number(
                data_list.trans_amt - data_list.deposit
              ).toFixed(2);
              is_total = true;
              await this.setState({ data_list, is_total });
            }
          }
        });
      }
    } else {
      Toast({
        type: "error",
        message: "Quantity should not be empty",
      });
    }
  };

  // handleTextChangeAPI = body => {
  //   let { data_list } = this.state;
  //   this.props.commonCreateApi(`coursetmp/`, body).then(key => {
  //     let { status, data } = key;
  //     console.log(key, "Coursecountupdateresponse");
  //     if (status == "201" || status == "200") {
  //       if (data) {
  //         data_list["tmp_treatment"] = data;
  //         this.setState({ data_list });
  //         this.getCourseAfterTreatmentDoneAction();
  //         return true;
  //       }
  //     }
  //   });
  // };
  handleReset = () => {
    let { data_list, is_total, discount_reasons, discount_price_txt } =
      this.state;
    let body = {
      cart_id: data_list.id,
    };
    this.props
      .commonCreateApi(`cartservicecourse/reset/`, body)
      .then(async (key) => {
        let { status, data } = key;
        console.log(key, "resetresponse");
        if (status == "200") {
          data_list.tmp_treatment = [];
          discount_reasons = [];
          data_list["treatment_no"] = "";
          data_list["free_sessions"] = "";
          // data_list["quantity"] = 1;
          // data_list["price"] = Number(data_list["price"])
          // data_list["discount_price"] = Number(data_list["price"]);
          // data_list["trans_amt"] = Number(data_list["price"]);
          // data_list["deposit"] = Number(data_list["price"]);
          // data_list["outstanding"] = Number(
          //   data_list.trans_amt - data_list.deposit
          // ).toFixed(2);
          //data_list["autoProportion"] = false;
          discount_price_txt = "";
          is_total = false;
          this.setState({
            data_list,
            is_total,
            discount_reasons,
            discount_price_txt,
          });
          this.getCourseAfterReset();
        }
      });
  };

  getCourseAfterReset = () => {
    let { sessionStaff, data_list, changeprice } = this.state;
    this.props
      .getCommonApi(`cartservicecourse/${this.props.cartId}/`)
      .then((key) => {
        let { status, data } = key;
        console.log(data, "cartcoursepopup");
        if (status == "200") {
          if (data) {
            data_list["autoProportion"] = data?.auto_proportion;
            data_list["price"] = Number(data.price).toFixed(2);
            data_list["discount_price"] = Number(data.price).toFixed(2);
            data_list["quantity"] = Number(data.quantity);
            data_list["total_price"] = Number(data.total_price).toFixed(2);
            data_list["trans_amt"] = Number(data.trans_amt);
            data_list["outstanding"] = Number(
              data.trans_amt - data.deposit
            ).toFixed(2);
            data_list["deposit"] = Number(data.deposit).toFixed(2);
            data_list["is_done"] = data.is_done;
            if (
              data.sessiondone == "" ||
              Number(data.sessiondone) == 0 ||
              data.sessiondone == null ||
              data.sessiondone == undefined
            ) {
              data_list["Sessions"] = 0;
            } else {
              data_list["Sessions"] = data.sessiondone;
            }
            sessionStaff = [];
            sessionStaff = data.tstaff;
            changeprice = Number(data.trans_amt).toFixed(2);
            console.log("apiCallforTreatmentCount", changeprice);
            this.setState({
              sessionStaff,
              data_list,
              changeprice,
            });
          }
        }
      });
  };

  handleQuantityCount = async () => {
    let { data_list } = this.state;
    let count = 0;

    count = Number(data_list.treatment_no) + Number(data_list.free_sessions);
    if (count > 0) {
      data_list["quantity"] = count;
    } else {
      data_list["quantity"] = 1;
    }
    await this.setState({
      data_list,
    });
  };

  // handleSubmitHandler

  handleSubmitHandler = () => {
    let { tokenDetails } = this.props;
    if (tokenDetails?.course_servicelimitchange) {
      if (this.state.course_type_max_treat_qty < 0) {
        Toast({
          type: "error",
          message: "please enter valid maximum treatement Qty",
        });
        return false;
      }
      if (
        (this.state.course_type == "FFd" || this.state.course_type == "FFi") &&
        this.state.course_type_max_treat_qty >= 0
      ) {
        this.setState({
          isStaffLoginConfirmation: true,
        });
      } else {
        this.handleSubmit();
      }
    } else {
      this.handleSubmit();
    }
  };

  // handleStaffLoginConfirmationDialog
  handleStaffLoginConfirmationDialog = () => {
    this.setState({
      isStaffLoginConfirmation: false,
    });
  };

  // handleSubmit
  handleSubmit = (user, pass) => {
    let {
      data_list,
      course_type,
      course_type_expiry_date,
      course_type_max_treat_qty,
    } = this.state;
    let discountAmt = null;
    let discount = null;
    if (data_list.discount && Number(data_list.discount) <= 0) {
      discount = 0;
      let discountCal = Number(
        data_list.discount_amt / data_list.treatment_no
      ).toFixed(2);
      discountAmt = discountCal;
    } else {
      let trans = Number(data_list.treatment_no) * Number(data_list.price);
      let discPercnt = Number(
        (trans * Number(data_list.discount)) / 100
      ).toFixed(2);

      let disccalcStage = Number(trans - discPercnt).toFixed(2);
      let disccalStage2 = Number(
        disccalcStage / data_list.treatment_no
      ).toFixed(2);
      let disccalcfinal = Number(data_list.price - disccalStage2);
      discountAmt = disccalcfinal;
      let Singledisc_percnt = Number(discountAmt / 100).toFixed(2);
      discount = Number(Singledisc_percnt * 100).toFixed(2);
    }
    let treatment_no = 0;
    if (data_list.treatment_no > 0) {
      treatment_no = data_list.treatment_no;
    } else {
      treatment_no = 1;
    }
    let serviceremark = "";
    if (data_list.remark === undefined || data_list.remark === "") {
      serviceremark = "[]";
    } else {
      serviceremark = data_list.remark;
    }
    console.log("serviceremark", serviceremark);
    // Get today's date
    var todaysDate = new Date();
    //course_type_expiry_date=data.treat_expiry==null?new Date():data.treat_expiry;
    if (course_type_expiry_date === undefined) {
      course_type_expiry_date = todaysDate;
    }
    console.log(course_type_expiry_date);
    //if (course_type_expiry_date == todaysDate) {
    //  course_type_expiry_date = null;
    // }

    if (Number(data_list["deposit"]) > Number(data_list["trans_amt"])) {
      Toast({
        type: "error",
        message: "Deposit should be less than or equal to Total price",
      });
      return false;
    } else if (discountAmt > 0 && data_list.disc_reason == "") {
      Toast({
        type: "error",
        message: "discount reason is mandatory for discount apply",
      });
      return false;
    } else {
      let body = {
        cart_id: data_list.id,
        quantity: Number(data_list.quantity),
        price: Number(data_list.price),
        discount_price: Number(data_list.discount_price),
        trans_amt: Number(data_list.trans_amt),
        deposit: Number(data_list.deposit),
        treatment_no: Number(data_list.treatment_no),
        free_sessions: Number(data_list.free_sessions),
        itemdesc: data_list.itemdesc,
        remark: data_list.remark,
        //Yoonus stopping qty * price calculation in frontend where user directly change price
        //total_price: Number(
        //  Number(treatment_no) * Number(data_list.price)
        //).toFixed(2),
        total_price: Number(data_list.trans_amt),

        sessiondone: data_list.is_done == true ? 0 : Number(data_list.Sessions),

        is_flexi: course_type == "N" ? false : true,

        // call setHours to take the time out of the comparison
        //if(course_type_expiry_date.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)) {
        //  // Date equals today's date
        // }

        //treat_expiry: course_type_expiry_date.setHours(0,0,0,0) == todaysDate.setHours(0,0,0,0)?null: dateFormat(new Date(course_type_expiry_date), "yyyy-mm-dd"), course_type_expiry_date,
        treat_expiry: dateFormat(
          new Date(course_type_expiry_date),
          "yyyy-mm-dd"
        ),
        course_type_expiry_date,
        treat_type: course_type,
        treatment_limit_times:
          course_type == "N" ? 0 : course_type_max_treat_qty,
      };
      console.log(body, "Confirm button action input");
      if (user) body.username = user ?? "";
      if (pass) body.password = pass ?? "";
      this.props
        .commonPatchApi(`cartservicecourse/${this.props.cartId}/`, body)
        .then((key) => {
          let { status, data } = key;
          if (status == "200") {
            this.props.handleModal();
          }
        });
    }
  };

  getDiscountReasons = () => {
    let { discount_reason_options } = this.state;

    this.props.getCommonApi(`paymentremarks/`).then((key) => {
      let { status, data } = key;
      if (status === 200) {
        for (let value of data) {
          discount_reason_options.push({
            value: value.id,
            label: value.r_desc,
          });
        }
        this.setState({ discount_reason_options });
      }
    });
  };
  handleApplyDiscount = async () => {
    let { data_list, discount_price_txt, is_percentage } = this.state;

    console.log(data_list.disc_reason);
    if (Number(data_list.disc_reason) == 182) {
      Toast({
        type: "error",
        message: "Please select Discount Reason",
      });
      return false;
    }

    if (Number(discount_price_txt) > 0) {
      if (Number(is_percentage) == 1) {
        if (data_list.disc_reason && data_list.disc_reason != "") {
          data_list["discount_amt"] = Number(
            (Number(data_list["discount_price"]) / 100) *
              Number(discount_price_txt)
          );

          data_list["discount"] = Number(discount_price_txt);
          await this.setState({ data_list });
        } else {
          Toast({
            type: "error",
            message: "Please select Discount Reason",
          });
          return false;
        }
      } else if (Number(is_percentage) == 2) {
        if (data_list.disc_reason && data_list.disc_reason != "") {
          data_list["discount_amt"] = Number(discount_price_txt);
          data_list["discount"] = null;
          await this.setState({ data_list });
        } else {
          Toast({
            type: "error",
            message: "Please select Discount Reason",
          });
          return false;
        }
      } else {
        Toast({
          type: "error",
          message: "Please select Discount Type",
        });
        return false;
      }
      let discreason_text = "";
      if (Number(data_list.disc_reason) == 182) {
        discreason_text = "others";
      } else {
        discreason_text = "";
      }
      let body = {
        discount: Number(data_list.discount),
        discount_amt: Number(data_list.discount_amt),
        disc_reason: Number(data_list.disc_reason),
        discreason_txt: discreason_text,
      };
      this.props
        .commonUpdateApi(
          `itemcart/${this.props.cartId}/?disc_add=1&disc_reset=0&auto=${
            data_list.autoProportion ? 1 : 0
          }`,
          body
        )
        .then((key) => {
          let { status, data } = key;
          console.log(key, "apply discount response");
          if (status == "200" || status == "201") {
            this.getCourseTableList();
            // if (data_list["autoProportion"]) {
            //   this.handleProportiononDiscountChange()
            // }
          }
        });
    } else {
      Toast({
        type: "error",
        message: "Discount should be greater than zero",
      });
      return false;
    }
  };

  handleResetDiscount = async () => {
    let { data_list } = this.state;
    let body = {
      discount: Number(data_list.discount),
      discount_amt: Number(data_list.discount_amt),
      disc_reason: Number(data_list.disc_reason),
      discreason_txt: data_list.discreason_txt,
    };

    this.props
      .commonUpdateApi(
        `itemcart/${this.props.cartId}/?disc_add=0&disc_reset=1&auto=${
          data_list.autoProportion ? 1 : 0
        }`,
        body
      )
      .then((key) => {
        console.log(key, "handleresetDiscount");
        this.getCourseTableList();
      });
  };
  handleDepositAmount = () => {
    let { data_list } = this.state;
    let { trans_amt, deposit, outstanding } = data_list;
    data_list["outstanding"] = Number(trans_amt - deposit).toFixed(2);
    this.setState({
      data_list,
    });
  };
  handleDialog = async () => {
    let { isOpenTreatmentDone } = this.state;

    isOpenTreatmentDone = false;

    await this.setState({
      isOpenTreatmentDone,
      editCart: {},
    });
    this.getCourseAfterTreatmentDoneConfirm();
  };

  handleTreatmentDone = async () => {
    let { item, data_list } = this.state;
    let { editCart } = this.state;
    editCart = item;
    if (data_list["Sessions"] == 0 || data_list["Sessions"] == "") {
      data_list["Sessions"] = 1;
    }
    await this.setState({ editCart, data_list });
    this.setState({ isOpenTreatmentDone: true });
  };
  handleSummaryFlag = () => {
    this.setState((prevState) => ({
      summaryFlag: !prevState.summaryFlag,
    }));
  };

  handleSessionChange = async (event) => {
    //event.persist();
    let { data_list } = this.state;
    // data_list.treatment_no = event.target.value;
    data_list.treatment_no = Number(event);

    await this.setState({ data_list });

    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(async () => {
        this.handleSoftReset();
      }, 500);
    }
    this.debouncedFn();
  };

  handleServiceChange = (text) => {
    //event.persist();
    if (text.length < 80) {
      let data = { ...this.state.data_list };
      // data.itemdesc = event.target.value;
      data.itemdesc = text;
      this.setState({
        data_list: data,
      });
    }
    // console.log(event.target.value,"fffffffffff")
  };

  handleRemarkChange = (text) => {
    if (text.length < 250) {
      let data = { ...this.state.data_list };
      console.log(text, "remarks text");
      data.remark = text;
      this.setState({
        data_list: data,
      });
    }
  };

  handleFocChange = async (event) => {
    //event.persist();
    let {
      data_list,
      is_total,
      discount_reasons,
      discount_price_txt,
      changeprice,
    } = this.state;
    // data_list.free_sessions = event.target.value;
    data_list.free_sessions = Number(event);

    await this.setState({ data_list });

    if (!this.debouncedFnFoc) {
      this.debouncedFnFoc = _.debounce(async () => {
        this.props
          .getCommonApi(`cartservicecourse/${this.props.cartId}/`)
          .then(async (key) => {
            let { status, data } = key;
            if (status == "200") {
              if (data_list?.treatment_no > 0) {
                changeprice =
                  Number(data_list?.treatment_no) *
                  Number(data_list?.discount_price);
              } else {
                changeprice = Number(data.changeprice);
              }
              await this.setState({
                changeprice,
              });
            }
          });

        if (data_list.treatment_no == null) {
          this.handleTreatmentnewCountUpdate();
        } else {
          let dataFirstCall = false;
          this.handleTreatmentCountUpdate(dataFirstCall, Number(changeprice));
        }
      }, 600);
    }
    this.debouncedFnFoc();
  };

  // handleDepositOnChange
  handleDepositOnChange = async (val) => {
    //event.persist();

    let { data_list } = this.state;
    // data_list.deposit = event.target.value;
    data_list.deposit = Number(val);
    await this.setState({ data_list });
    if (!this.debouncedFnDeposit) {
      this.debouncedFnDeposit = _.debounce(async () => {
        this.handleDepositAmount();
      }, 500);
    }
    this.debouncedFnDeposit();
  };
  handleSoftReset = () => {
    let {
      data_list,
      is_total,
      discount_reasons,
      discount_price_txt,
      changeprice,
    } = this.state;
    let body = {
      cart_id: data_list.id,
    };
    this.props
      .commonCreateApi(`cartservicecourse/reset/`, body)
      .then(async (key) => {
        let { status, data } = key;
        console.log(key, "resetresponse");
        if (status == "200") {
          data_list.tmp_treatment = [];

          // if foc function handle not able to access

          discount_reasons = [];

          //data_list["treatment_no"] = "";
          //data_list["free_sessions"] = "";
          // data_list["quantity"] = 1;
          data_list["price"] = Number(data_list["price"]);
          data_list["discount_price"] = Number(data_list["price"]).toFixed(2);
          data_list["trans_amt"] = Number(data_list["price"]);
          data_list["deposit"] = Number(data_list["price"]).toFixed(2);
          data_list["outstanding"] = Number(
            data_list.trans_amt - data_list.deposit
          ).toFixed(2);
          // data_list["autoProportion"] = false;
          // if (this.props.tokenDetails?.courseautoproportion) {
          //   data_list["autoProportion"] = true;
          // }
          discount_price_txt = "";
          //is_total = false; //Yoonus
          changeprice = Number(data_list["price"]).toFixed(2);
          this.setState({
            data_list,
            is_total,
            discount_reasons,
            discount_price_txt,
            changeprice,
          });
          //this.getCourseAfterReset();
          if (data_list.treatment_no == null) {
            this.handleTreatmentnewCountUpdate();
          } else {
            let dataFirstCall = false;
            this.handleTreatmentCountUpdate(dataFirstCall);
          }
        }
      });
  };

  handleDialogSalesStaff = () => {
    let { isOpenStaffSelectionDetail } = this.state;
    isOpenStaffSelectionDetail = !isOpenStaffSelectionDetail;
    this.setState({
      isOpenStaffSelectionDetail,
    });
  };

  handleLoginConfirmationDialog = async () => {
    await this.setState((prevState) => ({
      isLoginConfirmation: !prevState.isLoginConfirmation,
    }));
  };

  handleauthentication = async (user, pass) => {
    let { data_list } = this.state;
    let Body = {
      username: user,
      password: pass,
      type: "CartDisc",
      discount: Number(data_list.discount),
      itemname: data_list.itemdesc,      
    };
    this.props
      .commonCreateApi(`userauthorizationpopup/`, Body)
      .then(async (key) => {
        let { status, data } = key;
        if (status == 200) {
          await this.setState((prevState) => ({
            isLoginConfirmation: !prevState.isLoginConfirmation,
          }));
          this.handleApplyDiscount();
        }
      });
  };

  // handleToFoucsInput
  handleToFoucsInput = async (elem) => {
    const searchTextInput = document.getElementById(elem);
    searchTextInput.focus();
    setTimeout(() => {
      searchTextInput.blur();
    }, 100);
    // The input will lose focus after 3 seconds
  };

  render() {
    let {
      data_list,
      headerDetails,
      is_percentage,
      discount_reason_options,
      discount_reasons,
      is_total,
      discount_price_txt,
      discType,
      options_course_type,
      course_type,
      course_type_expiry_date,
      course_type_max_treat_qty,
      TD_List,
      isOpenTreatmentDone,
      cartId,
      summaryFlag,
      sessionStaff,
      isOpenStaffSelectionDetail,
      editCart,
      settingData,
      isHandleConfirmationDialog,
      isLoginConfirmation,
      user,
      pass,
      changeprice,
    } = this.state;
    let {
      deposit,
      discount,
      discount_amt,
      discount_price,
      free_sessions,
      id,
      itemdesc,
      remark,
      price,
      quantity,
      tmp_treatment,
      total_price,
      trans_amt,
      treatment_no,
      outstanding,
      disc_reason,
      discreason_txt,
      autoProportion,
      Sessions,
      is_done,
    } = data_list;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid mb-4">
          <div className="row pl-3 mb-2">
            <div className="col-md-10 col-12">
              <h4>{t("Course Pages ")}</h4>
            </div>

            <div className="col-md-2 col-12">
              <NormalButton
                mainbg={false}
                className="col-12 submit-btn"
                label="Done"
                onClick={this.handleSubmitHandler}
              />
            </div>
          </div>

          <div className="row">
            <div className="d-flex flex-wrap w-100 mb-3 p-2">
              <div className="col-md-5 col-12 mb-3 border">
                <div className="row p-0 m-0">
                  <div className="col-md-12 col-12 mb-2">
                    <label className="text-left text-black common-label-text pb-2">
                      {t("Service")} {t("Course")}
                    </label>
                    <div className="input-group">
                      {/* <InputKeyboard
                        id="serviceCouse"
                        value={itemdesc}
                        onChange={(e) => this.handleServiceChange(e)}
                        onFocus={() => this.handleToFoucsInput("serviceCouse")}
                      /> */}
                      {/* <SearchInputKeyboard
                        onRef={(ref) => (this.child = ref)}
                        value={itemdesc}
                        onChangeTextInput={(e) =>
                          this.handleServiceChange(e.target.value)
                        }
                        onChangeKeyboard={this.handleServiceChange}
                        handleIconSearch={() => {
                          this.handleIconSearch();
                        }}
                        focusValue={"serviceCouse"}
                        placeHolderText={"Search Customer.."}
                        isSearchIcon={false}
                      /> */}

                      {console.log(
                        "this.state.data_list.itemdesc",
                        this.state.data_list.itemdesc
                      )}

                      {this.props.tokenDetails.ipadkey ? (
                        <SearchInputKeyboard
                          onRef={(ref) => (this.childInput = ref)}
                          onChangeTextInput={(e) => this.handleServiceChange(e)}
                          focusValue={"serviceCouse"}
                          placeHolderText={""}
                          isSearchIcon={false}
                          parentPassIntialValue={this.state.data_list.itemdesc}
                          disabled={
                            !this.props.tokenDetails.allowchangecoursename
                          }
                        />
                      ) : (
                        <NormalInput
                          placeholder=""
                          value={itemdesc}
                          onChange={(e) =>
                            this.handleServiceChange(e.target.value)
                          }
                          maxLength={80}
                          disabled={
                            !this.props.tokenDetails.allowchangecoursename
                          }
                        />
                      )}
                    </div>
                  </div>
                  <div className="col-md-4 col-12">
                    <label className="text-left text-black common-label-text  pb-2">
                      {t("QTY")}
                    </label>

                    <div className="input-group">
                      {this.props.tokenDetails.ipadkey ? (
                        <NumPadKeyboard
                          onChange={(e) => this.handleSessionChange(e)}
                          value={
                            treatment_no === null
                              ? quantity || 1
                              : treatment_no
                              ? treatment_no
                              : 1
                          }
                          decimal={false}
                        />
                      ) : (
                        <NormalInput
                          placeholder=""
                          value={
                            treatment_no === null
                              ? quantity
                              : treatment_no
                              ? treatment_no
                              : "1"
                          }
                          type="number"
                          name="treatment_no"
                          onChange={(e) =>
                            this.handleSessionChange(e.target.value)
                          }
                          // onBlur={this.handleQuantityCount}
                        />
                      )}
                    </div>
                  </div>

                  {
                    //Yoonus block for healspa
                    <div className="col-md-4 col-12">
                      <label className="text-left text-black common-label-text  pb-2">
                        {t("FOC")}
                      </label>
                      <div className="input-group">
                        {this.props.tokenDetails.ipadkey ? (
                          <NumPadKeyboard
                            onChange={(e) => this.handleFocChange(e)}
                            value={free_sessions ? free_sessions : ""}
                            decimal={false}
                          />
                        ) : (
                          <NormalInput
                            placeholder=""
                            value={free_sessions ? free_sessions : ""}
                            type="number"
                            name="free_sessions"
                            onChange={(e) =>
                              this.handleFocChange(e.target.value)
                            }
                            //onChange={this.handleChange}
                            // onBlur={this.handleQuantityCount}
                          />
                        )}
                      </div>
                    </div>
                  }

                  <div className="col-md-4 col-12 align-self-end">
                    <div className="d-flex flex-row justify-content-around">
                      {/*<div className="mr-1">
                        <NormalButton
                          className={"col-12 btn-outline-success applybtn"}
                          applybg={true}
                          label="Apply"
                          onClick={() => this.handleTreatmentCountUpdate(false)}
                        />
                      </div>*/}

                      <div className="">
                        <NormalButton
                          resetbg={true}
                          className={"col-12 btn-outline-danger resetbtn"}
                          label="Reset"
                          onClick={this.handleReset}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row p-0 m-0">
                  <div className="row p-3">
                    <div className="col-md-4 col-12">
                      <label className="text-left text-black common-label-text pb-2">
                        {t("Total")} {t("QTY")}
                      </label>
                      <div className="input-group">
                        <NormalInput
                          placeholder=""
                          value={quantity ? quantity : ""}
                          type="number"
                          name="quantity"
                          onChange={() => {}}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-4 col-12 mb-2">
                      <label className="text-left text-black common-label-text pb-2">
                        {t("Unit Price")}
                      </label>

                      <div className="input-group">
                        <NormalInput
                          placeholder=""
                          value={price}
                          type="number"
                          name="price"
                          onChange={(e) => this.handleChange(e, "price")}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4 col-12 mb-2 text-right workstaff-background">
                      <label className="text-black common-label-text pb-1">
                        {t("Disc.")} {t("Price")}
                      </label>
                    </div>
                    <div className="col-md-4 col-12 mb-2 workstaff-background">
                      <div className="input-group">
                        <NormalInput
                          placeholder=""
                          value={discount_price}
                          name="discount_price"
                          onChange={() => {}}
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-2 workstaff-background"></div>
                    <div className="col-md-4 col-12 mb-2 text-right">
                      <label className="text-right text-black common-label-text pb-1">
                        {t("Total")} {t("Price")}
                      </label>
                    </div>

                    <div className="col-md-4 col-12  mb-2">
                      {/* is_unitprice=false means dont show the change price textbox Yoonus for zenth  */}
                      {this.props.tokenDetails.ipadkey ? (
                        <NumPadKeyboard
                          onChange={(e) => this.handleChange(e, "changeprice")}
                          value={changeprice}
                        />
                      ) : (
                        <div className="input-group">
                          <NormalInput
                            placeholder=""
                            value={changeprice}
                            name="changeprice"
                            type="number"
                            onChange={this.handleChange1}
                            disabled={
                              discount_reasons.length > 0 || !is_done || !settingData.is_unitprice
                                ? true
                                : false
                            }
                          />
                        </div>
                      )}
                    </div>

                    <div className="col-md-4 col-12">
                      {/* Yoonus settingData.allowToChangeTotalAmountInCourse === false means disable the change button */}
                      {(discount_reasons && discount_reasons.length > 0) ||
                      !is_done ? null : (
                        <NormalButton
                          buttonClass={"w-100"}
                          styleTwo={true}
                          label="Change"
                          onClick={this.handleTotalPriceChange}
                          disabled={
                            tmp_treatment && tmp_treatment.length > 0 && settingData.allowToChangeTotalAmountInCourse
                              ? false
                              : true
                          }
                        />
                      )}
                    </div>
                    <div className="col-md-4  mb-2"></div>
                    <div className="col-md-4 d-flex justify-content-center align-self-end  mb-2">
                      {console.log("autoProportion", autoProportion)}
                      <NormalCheckbox
                        name="autoProportion"
                        label="Auto Proportion"
                        checked={autoProportion}
                        value={autoProportion}
                        onChange={(e) => this.handleProportionChange(e)}
                        disabled={
                          tmp_treatment && tmp_treatment.length > 0
                            ? false
                            : true
                        }
                      />
                    </div>
                    <div className="col-md-4 mb-2"></div>
                    <div className="col-md-4 col-12 mb-2 text-right">
                      <label className="text-black common-label-text">
                        {t("Deposit")}
                      </label>
                    </div>
                    <div className="col-md-4 col-12 pb-1 pt-1 mb-2">
                      {this.props.tokenDetails.ipadkey ? (
                        <NumPadKeyboard
                          onChange={(e) => this.handleDepositOnChange(e)}
                          value={deposit}
                        />
                      ) : (
                        <div className="input-group">
                          <NormalInput
                            placeholder=""
                            value={deposit}
                            type="number"
                            name="deposit"
                            onChange={(e) =>
                              this.handleDepositOnChange(e.target.value)
                            }
                            //onBlur={this.handleDepositAmount}
                            // disabled={
                            //   tmp_treatment.length < 1 || !is_done ? true : false
                            // }
                            disabled={!is_done ? true : false}
                          />
                        </div>
                      )}
                    </div>
                    <div className="col-md-4 mb-2"></div>
                    <div className="col-md-4 col-12 mb-2 text-right">
                      <label className=" text-black common-label-text">
                        {t("Outstanding")}
                      </label>
                    </div>
                    <div className="col-md-4 col-12 pb-1 pt-1 mb-2">
                      <div className="input-group">
                        <NormalInput
                          placeholder=""
                          value={outstanding ? outstanding : ""}
                          type="number"
                          name="outstanding"
                          onChange={() => {}}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="col-md-4 mb-2"></div>
                  </div>

                  {/* Yoonus add remarks per service line */}
                  <div className="col-md-12 col-12 mb-2">
                    <label className="text-left text-black common-label-text pb-2">
                      {t("Service")} {t("Remarks")}
                    </label>
                    <div className="input-group">

                      {this.props.tokenDetails.ipadkey ? (
                        <SearchInputKeyboard
                          onRef={(ref) => (this.childInput = ref)}
                          focusValue={"serviceRemarks"}
                          onChangeTextInput={(e) => this.handleRemarkChange(e)}
                          placeHolderText={""}
                          isSearchIcon={false}
                          parentPassIntialValue={this.state.data_list.remark}
                        />
                      ) : (
                        <NormalInput
                          placeholder=""
                          value={remark}
                          onChange={(e) =>
                            this.handleRemarkChange(e.target.value)
                          }
                          maxLength={250}
                        />
                      )}
                    </div>
                  </div>
                  {/* Yoonus add remarks per service line */}

                </div>
              </div>
              <div className="col-md-7 col-12 mb-3 ">
                <div className="p-2 border">
                  <div className="d-flex flex-wrap mb-2">
                    <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 col-12">
                      <label className="text-left text-black common-label-text pb-2">
                        {t("Session")}
                      </label>
                    </div>

                    {this.props.tokenDetails.ipadkey ? (
                      <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 col-12">
                        <NumPadKeyboard
                          onChange={(e) => this.handleChange(e, "Sessions")}
                          value={Sessions}
                          decimal={false}
                        />
                      </div>
                    ) : (
                      <div className="col-12 col-sm-2 col-md-3 col-lg-3 col-xl-2">
                        <div className="input-group">
                          <NormalInput
                            placeholder=""
                            value={Sessions}
                            type="number"
                            name="Sessions"
                            onChange={this.handleChange1}
                            disabled={is_done ? false : true}
                          />
                        </div>
                      </div>
                    )}

                    <div className="col-12 col-sm-2 col-md-3 col-lg-3 col-xl-2">
                      <NormalButton
                        mainbgrev={true}
                        label="TD"
                        onClick={this.handleTreatmentDone}
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-wrap mb-2 mt-2">
                    <div className="col-12 col-sm-7 col-md-6 col-lg-7 col-xl-8 justify-content-start  mt-2">
                      <label className="fw-500">{t("TD Staff List")}</label>
                    </div>

                    <div className="col-12 col-sm-5 col-md-6 col-lg-5 col-xl-4 justify-content-end">
                      {(Number(this.props.tokenDetails.role_code) == 1 ||
                        Number(this.props.tokenDetails.role_code) == 2) &&
                      settingData.showCourseChangeStaff ? (
                        <NormalButton
                          label="Sales Staff"
                          mainbgrev={true}
                          onClick={this.handleDialogSalesStaff}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="col-6">
                      <label className="text-left text-black common-label-text pb-2 fw-500">
                        {t("Staff")}
                      </label>
                    </div>
                    <div className="col-2 text-center">
                      <label className="text-black common-label-text pb-2 fw-500">
                        {t("Session")}
                      </label>
                    </div>
                    <div className="col-2 text-center">
                      <label className="text-black common-label-text pb-2 fw-500">
                        {t(`WP`)}
                      </label>
                    </div>
                  </div>
                  <div className="d-flex flex-wrap">
                    <div className="col-md-12 w-100 bg-light p-3 border">
                      {sessionStaff &&
                        sessionStaff.length > 0 &&
                        sessionStaff.map((item, index) => {
                          return (
                            <div className="row" key={index}>
                              <div className="col-6 text-left ">
                                <label className="text-black common-label-text pb-2">
                                  {item.name}
                                </label>
                              </div>
                              <div className="col-2 text-right">
                                <label className="text-black common-label-text pb-2">
                                  {Number(item.session).toFixed(2)}
                                </label>
                              </div>
                              <div className="col-2 text-right">
                                <label className="align-self-end text-right text-black common-label-text pb-2">
                                  {Number(item.wp1).toFixed(2)}
                                </label>
                              </div>
                            </div>
                          );
                        })}
                      {!sessionStaff || sessionStaff.length <= 0 ? (
                        <div className="col-12">{t("No record found")}</div>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-wrap mb-2">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <label className="text-left text-black common-label-text pb-1">
                      {t("Course Type")}
                    </label>
                    <div className="input-group">
                      <NormalSelect
                        isPlaceholderNeed={false}
                        options={options_course_type}
                        value={course_type}
                        name="course_type"
                        onChange={this.handleChange1}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4">
                    <label className="text-left text-black common-label-text pb-1">
                      {t("Date")}
                    </label>
                    <div className="input-group">
                      <NormalDate
                        value={new Date(course_type_expiry_date)}
                        name="course_type_expiry_date"
                        type="date"
                        onChange={this.handleChange1}
                        minDate={new Date()}
                      />
                    </div>
                  </div>
                  {course_type != "Normal" && (
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                      <label className="text-left text-black common-label-text pb-1">
                        {t("Max Treat Qty")}
                      </label>
                      {this.props.tokenDetails.ipadkey ? (
                        <NumPadKeyboard
                          onChange={(e) =>
                            this.handleChange(e, "course_type_max_treat_qty")
                          }
                          value={course_type_max_treat_qty || 0}
                          decimal={false}
                        />
                      ) : (
                        <div className="input-group">
                          <NormalInput
                            value={course_type_max_treat_qty || 0}
                            type="number"
                            name="course_type_max_treat_qty"
                            onChange={this.handleChange1}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="p-2 mt-3 border workstaff-background">
                  <div className="d-flex flex-wrap mb-2">
                    <div className="col-12 col-md-3 ">
                      <label className="text-left text-black common-label-text pb-1">
                        {t("Discount")}
                      </label>
                      {this.props.tokenDetails.ipadkey ? (
                        <div className="input-group courseDiscountInputContainer">
                          <NumPadKeyboard
                            onChange={(e) =>
                              this.handleChange(e, "discount_price_txt")
                            }
                            value={discount_price_txt}
                            customClassName="w-100"
                          />
                        </div>
                      ) : (
                        <div className="input-group">
                          <NormalInput
                            placeholder=""
                            value={discount_price_txt}
                            type="number"
                            name="discount_price_txt"
                            onChange={this.handleChange1}
                            disabled={
                              (tmp_treatment && tmp_treatment.length < 1) ||
                              is_done
                                ? false
                                : true
                            }
                          />
                        </div>
                      )}
                    </div>
                    <div className="col-12 col-md-3 ">
                      <div>
                        <label className="text-left text-black common-label-text pb-1">
                          {t("Type")}
                        </label>
                        <div className="input-group">
                          <NormalSelect
                            className={`col`}
                            options={discType}
                            value={is_percentage}
                            name="is_percentage"
                            onChange={this.handleChange1}
                            disabled={is_total ? true : false}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 ">
                      <label className="text-left text-black common-label-text pb-1">
                        {t("Discount Reason")}
                      </label>
                      <div className="input-group">
                        <NormalSelect
                          options={discount_reason_options}
                          value={disc_reason}
                          name="disc_reason"
                          onChange={this.handleChange1}
                          disabled={is_total ? true : false}
                        />
                      </div>
                    </div>
                    {/* {disc_reason == "182" ? (
                      <div className="col-md-4 col-12">
                        <label className="text-left text-black common-label-text ">
                          {t("Discount reason")}
                        </label>
                        <div className="input-group mb-2">
                          <NormalTextarea
                            value={discreason_txt}
                            name="discreason_txt"
                            onChange={this.handleChange}
                            className="w-100"
                            disabled={is_total ? true : false}
                          />
                        </div>
                      </div>
                    ) : (
                      ""
                    )} */}

                    <div className="col-12 col-md-6 mt-4 pt-2">
                      <NormalButton
                        applybg={true}
                        className="col"
                        label="Apply Disc."
                        onClick={() => {
                          this.props.tokenDetails.cartdisc_setup
                            ? this.setState({ isLoginConfirmation: true })
                            : this.handleApplyDiscount();
                        }}
                        disabled={
                          is_total ||
                          (tmp_treatment && tmp_treatment.length < 0)
                            ? true
                            : false
                        }
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-wrap mb-2 mt-2">
                    <div className="col-md-8 justify-content-start col-12 mt-2">
                      <label className="fw-500">{t("Discount List")}</label>
                    </div>
                    {discount_reasons && discount_reasons.length > 0 ? (
                      <div className="col-md-4 pt-2 col-12 justify-content-end">
                        <NormalButton
                          resetbg={true}
                          className="col"
                          label="Reset Disc."
                          onClick={this.handleResetDiscount}
                          disabled={is_total ? true : false}
                        />
                      </div>
                    ) : null}
                  </div>
                  <div className="d-flex">
                    <div className="col-4">
                      <label className="text-left text-black common-label-text pb-2 fw-500">
                        {t("Remark")}
                      </label>
                    </div>
                    <div className="col-2 text-center">
                      <label className="text-black common-label-text pb-2 fw-500">
                        {t("Price")}
                      </label>
                    </div>
                    <div className="col-2 text-center">
                      <label className="text-black common-label-text pb-2 fw-500">
                        {t(`Disc. %`)}
                      </label>
                    </div>
                    <div className="col-2 text-center">
                      <label className="text-black common-label-text pb-2 fw-500">
                        {t(`Disc. $`)}
                      </label>
                    </div>
                    <div className="col-2 text-center">
                      <label className="text-black common-label-text pb-2 fw-500">
                        {t(`D/price`)}
                      </label>
                    </div>
                  </div>
                  <div className="d-flex flex-wrap">
                    <div className="col-md-12 w-100 bg-light p-3 border overflow-auto">
                      {discount_reasons &&
                        discount_reasons.length > 0 &&
                        discount_reasons.map((item, index) => {
                          return (
                            <div className="row" key={index}>
                              <div className="col-4">
                                <label className="text-left text-black common-label-text pb-2">
                                  {item.remark && item.remark !== ""
                                    ? item.remark
                                    : "OTHERS"}
                                </label>
                              </div>
                              <div className="col-2 text-right">
                                <label className=" text-black common-label-text pb-2">
                                  $ {item.amount}
                                </label>
                              </div>
                              <div className="col-2 text-right">
                                <label className="text-black common-label-text pb-2">
                                  {item.disc_per} %
                                </label>
                              </div>
                              <div className="col-2 text-right">
                                <label className="text-black common-label-text pb-2">
                                  $ {item.disc_amt}
                                </label>
                              </div>
                              <div className="col-2 text-right">
                                <label className="text-black common-label-text pb-2">
                                  $ {item.after_disc}
                                </label>
                              </div>
                            </div>
                          );
                        })}
                      {!discount_reasons || discount_reasons.length <= 0 ? (
                        <div className="row">{t("No record found")}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex flex-wrap w-100 mb-3 p-2 border">
              <div
                className="col-md-12 col-12"
                onClick={this.handleSummaryFlag}
              >
                <div className="d-flex">
                  <div className="h6 col-6 col-md-9 text-left">
                    {t("Summary List")}
                  </div>
                  <div className="h6 col-6 col-md-3 text-right fs-18">
                    {summaryFlag ? <>&#8593;</> : <>&#8595;</>}
                  </div>
                </div>
              </div>
              <div className={`table mb-2" + ${summaryFlag ? "" : "d-none"}`}>
                <TableWrapper headerDetails={headerDetails}>
                  {tmp_treatment && tmp_treatment.length > 0 ? (
                    tmp_treatment.map((item, index) => {
                      let { slno, program, next_appt, unit_amount } = item;
                      return (
                        <tr key={index}>
                          <td>
                            <div className="text-right">{slno}</div>
                          </td>

                          <td>
                            <div className="text-left">{program}</div>
                          </td>
                          <td>
                            <div className="text-right">{next_appt}</div>
                          </td>
                          <td>
                            <div className="text-right">{unit_amount}</div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="12">
                        <div className="d-flex align-items-center justify-content-center">
                          {`No record found`}
                        </div>
                      </td>
                    </tr>
                  )}
                </TableWrapper>
              </div>
            </div>
            <NormalModal
              className={"transaction-done-modal"}
              style={{ minWidth: "60%" }}
              modal={isOpenTreatmentDone}
              handleModal={() => {}}
            >
              <img
                onClick={this.handleDialog}
                className="close cursor-pointer"
                src={closeIcon}
                alt=""
              />
              {console.log(data_list, "data_list")}
              <CourseTreatmentDone
                id={cartId}
                cartId={this.props.cartId}
                sessionCount={data_list.Sessions}
                depositAmt={data_list.deposit}
                handleModal={this.handleDialog}
              ></CourseTreatmentDone>
            </NormalModal>
          </div>
        </div>
        {isOpenStaffSelectionDetail || !isOpenStaffSelectionDetail ? (
          <NormalModal
            className={"transaction-done-modal top-up-modal"}
            style={{ minWidth: "75%" }}
            modal={isOpenStaffSelectionDetail}
            handleModal={() => {}}
          >
            <img
              onClick={this.handleDialogSalesStaff}
              className="close cursor-pointer"
              src={closeIcon}
              alt=""
            />

            <StaffSelectionPopup
              id={this.props.id}
              cartId={this.props.cartId}
              LinelevelCartId={this.props.cartId}
              handleModal={this.handleDialogSalesStaff}
            ></StaffSelectionPopup>
          </NormalModal>
        ) : null}
        <NormalModal
          className={"d-flex justify-content-center"}
          style={{ minWidth: "20%" }}
          modal={isLoginConfirmation}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleLoginConfirmationDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <CredentialConfirmation
            handleLoginSubmit={(user, pass) =>
              this.handleauthentication(user, pass)
            }
          />
        </NormalModal>

        <NormalModal
          className={"d-flex justify-content-center"}
          style={{ minWidth: "20%" }}
          modal={this.state.isStaffLoginConfirmation}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleStaffLoginConfirmationDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <CredentialConfirmation
            handleLoginSubmit={(user, pass) => this.handleSubmit(user, pass)}
          />
        </NormalModal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      commonPatchApi,
      commonCreateApi,
      commonUpdateApi,
    },
    dispatch
  );
};
export const CoursePopup = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(CoursePopupClass)
);
